<script>
    import { createEventDispatcher } from "svelte";
    import Calender from "./Calender.svelte";
    import { getMonthName } from "./date-time.js";
  
    const dispatch = createEventDispatcher();
  
    // props
    export let isAllowed = () => true;
    export let selected = new Date();
    export let allwaysShow = false;
    export let boxStyle = null;
    export let inputStyle=null;
    export let disabled = false;
    export let reverse = false;
  
    // state
    let date, month, year, showDatePicker;
  
    // so that these change with props
    $: {
      date = selected.getDate();
      month = selected.getMonth();
      year = selected.getFullYear();
    }
  
    // handlers
    const onFocus = () => {
      showDatePicker = true;
    };
  
    const next = () => {
      if (month === 11) {
        month = 0;
        year = year + 1;
        return;
      }
      month = month + 1;
    };
  
    const prev = () => {
      if (month === 0) {
        month = 11;
        year -= 1;
        return;
      }
      month -= 1;
    };
  
    const onDateChange = d => {
      showDatePicker = false;
      dispatch("datechange", d.detail);
    };
  </script>
  
  <style>
    .relative {
      position: relative;
    }
    .box {
      position: absolute;
      top: 40px;
      left: 0px;
      border: 1px solid green;
      display: inline-block;
      z-index: 10000;
    }
  
    .month-name {
      display: flex;
      justify-content: space-around;
      align-items: center;
      margin: 6px 0;
    }
  
    .center {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .button {
        font-size: 2em;
        display: flex;
    }

    .flex-column {
        display: flex;
        flex-direction: column;
    }

    input {
      cursor:pointer;
    }
  </style>
  
  <div class="relative flex-column">
    <input type="text" on:focus={onFocus} value={selected.toISOString().slice(0,10) } style="{inputStyle}" disabled={disabled ? "disabled" : ""}/>
    {#if (showDatePicker || allwaysShow) && !disabled}
      <div class="box" style="{boxStyle} {allwaysShow ? ';position:relative;top:unset' : '' } {reverse ? ";right:0;left:unset" : ""}">
        <div class="month-name">
          <div class="center">
            <div class="button" on:click={prev}><ion-icon name="chevron-back-outline"></ion-icon></div>
          </div>
          <div class="center">{getMonthName(month)} {year}</div>
          <div class="center">
            <div class="button" on:click={next}><ion-icon name="chevron-forward-outline"></ion-icon></div>
          </div>
        </div>
        <Calender
          {month}
          {year}
          date={selected}
          {isAllowed}
          on:datechange={onDateChange} />
      </div>
    {/if}
    <slot></slot>
  </div>
  